module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [(_vm.post.data.body1[0]) ? _c('div', {
    staticClass: "video-header"
  }, [_c('content-video', {
    attrs: {
      "video": _vm.post.data.body1[0]
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "post-meta__category",
    domProps: {
      "innerHTML": _vm._s(_vm.category)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "block",
      "appear": ""
    }
  }, [_c('h1', {
    key: ((_vm.post.uid) + "-title"),
    staticClass: "post-title reveal-text",
    attrs: {
      "id": "video-article"
    }
  }, [_vm._v(_vm._s(_vm.title))])])], 1) : _c('div', {
    staticClass: "image-header"
  }, [_c('img', {
    staticClass: "post-image",
    attrs: {
      "src": _vm.post.data.featured_image.url,
      "alt": _vm.post.data.featured_image.alt,
      "width": _vm.post.data.featured_image.width,
      "height": _vm.post.data.featured_image.height
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "post-meta__category",
    domProps: {
      "innerHTML": _vm._s(_vm.category)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "block",
      "appear": ""
    }
  }, [_c('h1', {
    key: ((_vm.post.uid) + "-title"),
    staticClass: "post-title reveal-text"
  }, [_vm._v(_vm._s(_vm.title))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-842e7318"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleHeader.vue
// module id = 85
// module chunks = 0